export default __webpack_public_path__ + "static/media/twitter.1bc396b1.svg";